import styled from "styled-components";
import {container, down} from "../../Styles/media";

const Links = styled.div`
    ${container};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
    gap: clamp(12px, 1.6vw, 20px);
    padding-top: clamp(30px, 4vw, 48px);

    ${down('xs')} {
        grid-template-columns: minmax(0, 1fr);
    }
`

const Info = styled.div`
    ${container};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
    gap: clamp(12px, 1.6vw, 20px);
    padding-top: clamp(30px, 4vw, 48px);
`

export const Styled = {
    Links,
    Info
}
